import React from "react";
import styles from "./FollowButton.module.css";

/**
 * 关注按钮（公共组件）：心形图标 + Follow/Following 文案，样式统一
 * @param {boolean} following - 是否已关注
 * @param {function} onClick - 点击回调（内部需处理未登录、请求 saveOrCancel 等）
 * @param {boolean} [isLoggedIn] - 是否已登录
 * @param {function} [onRequireLogin] - 未登录时点击回调（如打开登录）
 * @param {string} [className] - 追加到按钮的 class，用于定位（如 absolute）
 */
const FollowButton = ({
  following,
  onClick,
  isLoggedIn,
  onRequireLogin,
  className = "",
}) => {
  const handleClick = async () => {
    if (isLoggedIn === false && onRequireLogin) {
      onRequireLogin();
      return;
    }
    try {
      await onClick?.();
    } catch (e) {
      console.warn("FollowButton onClick error:", e);
    }
  };

  return (
    <button
      type="button"
      className={`${styles.followBtn} ${className}`.trim()}
      onClick={handleClick}
    >
      <span
        className={`${styles.followBtnHeart} ${following ? styles.followBtnHeartActive : ""}`}
        aria-hidden="true"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill={following ? "currentColor" : "none"}
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      </span>
      <span>{following ? "Following" : "Follow"}</span>
    </button>
  );
};

export default FollowButton;
